<script setup>
import { cookieRef } from '@/@layouts/stores/config'
import AuditSummaryStrip from '@/views/quality/audit/dashboard/AuditSummaryStrip.vue'
import AuditComplianceByUnitGraph from '@/views/quality/audit/dashboard/AuditComplianceByUnitGraph.vue'
import AuditComplianceTrendGraph from '@/views/quality/audit/dashboard/AuditComplianceTrendGraph.vue'
import AuditCapaCard from '@/views/quality/audit/dashboard/AuditCapaCard.vue'
import AuditCoverageGraph from '@/views/quality/audit/dashboard/AuditCoverageGraph.vue'
import AuditStatusFunnel from '@/views/quality/audit/dashboard/AuditStatusFunnel.vue'
import AuditTopFindingsGraph from '@/views/quality/audit/dashboard/AuditTopFindingsGraph.vue'

definePage({
  meta: {
    subject: 'quality.menu',
    action: 'audit_collection',
  },
})

const now = new Date()

const selectedYear = ref(now.getFullYear())
const selectedAuditType = ref(null)
const selectedUnit = ref(cookieRef('selectedUnit', null).value)

const auditTypeOptions = [
  { title: 'All types', value: null },
  { title: 'General', value: 'GENERAL' },
  { title: 'Bundle Compliance', value: 'BUNDLE_COMPLIANCE' },
  { title: 'Hand Hygiene', value: 'HAND_HYGIENE' },
  { title: 'Environmental', value: 'ENVIRONMENTAL' },
]

const yearOptions = computed(() => {
  const current = now.getFullYear()

  return [current, current - 1, current - 2].map(y => ({ title: String(y), value: y }))
})

const dateFrom = computed(() => `${selectedYear.value}-01-01`)
const dateTo = computed(() => `${selectedYear.value}-12-31`)
</script>

<template>
  <div>
    <div class="d-flex flex-wrap align-center justify-space-between gap-4 mb-6">
      <div>
        <div class="text-h5">
          Audit Dashboard
        </div>
        <div class="text-body-2 text-medium-emphasis">
          Programme execution, compliance and corrective actions
        </div>
      </div>

      <div class="d-flex flex-wrap gap-3">
        <AppSelect
          v-model="selectedAuditType"
          :items="auditTypeOptions"
          item-title="title"
          item-value="value"
          style="inline-size: 13rem;"
        />
        <AppSelect
          v-model="selectedYear"
          :items="yearOptions"
          item-title="title"
          item-value="value"
          style="inline-size: 8rem;"
        />
      </div>
    </div>

    <VRow>
      <VCol cols="12">
        <AuditSummaryStrip
          :unit-id="selectedUnit"
          :audit-type="selectedAuditType"
          :date-from="dateFrom"
          :date-to="dateTo"
        />
      </VCol>
    </VRow>

    <VRow class="mt-2">
      <VCol
        cols="12"
        md="7"
      >
        <AuditComplianceTrendGraph
          :unit-id="selectedUnit"
          :audit-type="selectedAuditType"
          :date-from="dateFrom"
          :date-to="dateTo"
        />
      </VCol>
      <VCol
        cols="12"
        md="5"
      >
        <AuditComplianceByUnitGraph
          :unit-id="selectedUnit"
          :audit-type="selectedAuditType"
          :date-from="dateFrom"
          :date-to="dateTo"
        />
      </VCol>
    </VRow>

    <VRow class="mt-2">
      <VCol
        cols="12"
        md="7"
      >
        <AuditCoverageGraph
          :unit-id="selectedUnit"
          :audit-type="selectedAuditType"
          :date-from="dateFrom"
          :date-to="dateTo"
        />
      </VCol>
      <VCol
        cols="12"
        md="5"
      >
        <AuditTopFindingsGraph
          :unit-id="selectedUnit"
          :audit-type="selectedAuditType"
          :date-from="dateFrom"
          :date-to="dateTo"
        />
      </VCol>
    </VRow>

    <VRow class="mt-2">
      <VCol
        cols="12"
        md="7"
      >
        <AuditCapaCard
          :unit-id="selectedUnit"
          :audit-type="selectedAuditType"
          :date-from="dateFrom"
          :date-to="dateTo"
        />
      </VCol>
      <VCol
        cols="12"
        md="5"
      >
        <AuditStatusFunnel
          :unit-id="selectedUnit"
          :audit-type="selectedAuditType"
          :date-from="dateFrom"
          :date-to="dateTo"
        />
      </VCol>
    </VRow>
  </div>
</template>
